import api from './api';

/**
 * Сервис для работы с остановками
 */
const busStopsService = {
  /**
   * Получить все остановки
   */
  async getAll() {
    const response = await api.get('/busstops');
    return response.data;
  },

  /**
   * Получить первые N остановок (для отображения по умолчанию)
   * @param {number} limit - Количество остановок
   */
  async getFirst(limit = 3) {
    const response = await api.get('/busstops', {
      params: { limit }
    });
    return response.data;
  },

  /**
   * Получить остановку по ID
   */
  async getById(id) {
    const response = await api.get(`/busstops/${id}`);
    return response.data;
  },

  /**
   * Создать новую остановку
   */
  async create(busStop) {
    const response = await api.post('/busstops', busStop);
    return response.data;
  },

  /**
   * Обновить остановку
   */
  async update(id, busStop) {
    const response = await api.put(`/busstops/${id}`, busStop);
    return response.data;
  },

  /**
   * Удалить остановку
   */
  async delete(id) {
    await api.delete(`/busstops/${id}`);
  },

  /**
   * Поиск остановок
   */
  async search(query, language = 'tr') {
    const response = await api.get('/busstops/search', {
      params: { query, language }
    });
    return response.data;
  },
};

export default busStopsService;
